/**
 * Problem statement.
 *
 * The landing page argues from the group chat, not from a feature list: the
 * expensive part of planning an outing is that every member starts somewhere
 * else with a different budget of time. The three lines are the concrete shape of
 * that, and the conclusion names the product.
 */

import { MessageSquareWarning } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function LandingProblem() {
  const { t } = useTranslation()

  const items = [
    t('home.problemItemOne'),
    t('home.problemItemTwo'),
    t('home.problemItemThree'),
  ]

  return (
    <section className="landing-section" aria-labelledby="landing-problem-title">
      <div className="landing-container flex flex-col gap-4">
        <span className="text-muted-foreground inline-flex items-center gap-2 text-xs font-medium tracking-wide uppercase">
          <MessageSquareWarning className="size-4" aria-hidden />
          {t('nav.about')}
        </span>

        <h2
          id="landing-problem-title"
          className="max-w-3xl text-2xl font-semibold tracking-tight text-balance sm:text-3xl"
        >
          {t('home.problemTitle')}
        </h2>

        <ul className="grid gap-2 sm:grid-cols-3">
          {items.map((item) => (
            <li
              key={item}
              className="border-border bg-card rounded-2xl border px-4 py-2.5 text-sm font-medium"
            >
              {item}
            </li>
          ))}
        </ul>

        <p className="text-muted-foreground max-w-2xl text-base">{t('home.problemConclusion')}</p>
      </div>
    </section>
  )
}
